import getCartAction from "./getCartAction";
import businessPartnerRequest from "../../services/rest/request/account/businessPartnerRequest";
import getPaymentDetailsAction from "./getPaymentDetailsAction";

const prepareCheckout = async (session) => {
    const cartRes = await getCartAction(session, false);

    const returnVal = {
        ...cartRes,
        input: {},
        completedOrder: undefined
    }


    if(cartRes.orderID > 0) {// If the user has an active cart
        returnVal.bPartner = await businessPartnerRequest(session.bPartnerID)
            .sendIt(session);

        returnVal.paymentDetails = await getPaymentDetailsAction(session, returnVal.bPartner, cartRes.orderID, cartRes.order.GrandTotal);
    }

    return returnVal;
}

export default prepareCheckout;